import { Http } from '@/lib/http';

export class AmlCaseService extends Http {
  constructor() {
    super();
    this.endpoint = '/aml-pro/app/cases';
  }

  fetchAll(params = {}) {
    return this.httpClient().get(this.endpoint, { params });
  }

  fetchOne(id) {
    return this.httpClient().get(`${this.endpoint}/${id}`);
  }

  fetchByAccount(accountId) {
    return this.httpClient().get(`${this.endpoint}/account/${accountId}`);
  }

  fetchDashboardStats() {
    return this.httpClient().get(`${this.endpoint}/stats/dashboard`);
  }

  create(payload) {
    return this.httpClient().post(this.endpoint, payload);
  }

  update(id, payload) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, payload);
  }

  close(id, payload) {
    return this.httpClient().patch(`${this.endpoint}/${id}/close`, payload);
  }

  assign(id, assignedToUserId) {
    return this.httpClient().patch(`${this.endpoint}/${id}/assign`, { assignedToUserId });
  }

  deassign(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/deassign`);
  }

  reopen(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/reopen`);
  }

  addTransaction(id, payload) {
    return this.httpClient().post(`${this.endpoint}/${id}/transactions`, payload);
  }

  removeTransaction(id, txnId) {
    return this.httpClient().delete(`${this.endpoint}/${id}/transactions/${txnId}`);
  }

  addComment(id, payload) {
    return this.httpClient().post(`${this.endpoint}/${id}/comments`, payload);
  }

  updateComment(id, commentId, message) {
    return this.httpClient().patch(`${this.endpoint}/${id}/comments/${commentId}`, { message });
  }

  deleteComment(id, commentId) {
    return this.httpClient().delete(`${this.endpoint}/${id}/comments/${commentId}`);
  }

  addAction(id, payload) {
    return this.httpClient().post(`${this.endpoint}/${id}/actions`, payload);
  }

  updateAction(id, actionId, payload) {
    return this.httpClient().patch(`${this.endpoint}/${id}/actions/${actionId}`, payload);
  }

  /**
   * Fetch paginated AML activity across all cases.
   * @param {Object} params - { page, limit, action, actorId, from, to }
   */
  fetchActivity(params = {}) {
    return this.httpClient().get(`${this.endpoint}/stats/activity`, { params });
  }

  /**
   * Fetch paginated activity scoped to a single case.
   * @param {string} caseId
   * @param {Object} params - { page, limit, action, from, to }
   */
  fetchCaseActivity(caseId, params = {}) {
    return this.httpClient().get(`${this.endpoint}/stats/activity/${caseId}`, { params });
  }

  fetchOpenAlerts(accountId) {
    return this.httpClient().get(`${this.endpoint}/account/${accountId}/alerts`);
  }

  fetchFlaggedAttempts(accountId) {
    return this.httpClient().get(`${this.endpoint}/account/${accountId}/flagged-attempts`);
  }

  getFlaggedAttemptsByAccount(accountId) {
    return this.fetchFlaggedAttempts(accountId);
  }

  runAnalysis() {
    return this.httpClient().post(`${this.endpoint}/run-analysis`);
  }

  fetchAlerts(params = {}) {
    return this.httpClient().get(`${this.endpoint}/alerts`, { params });
  }

  fetchAccountTransactions(accountId, params = {}) {
    return this.httpClient().get(
      `${this.endpoint}/accounts/${accountId}/transactions`,
      { params },
    );
  }
}